import { Card, Collapse, Group, Text, UnstyledButton } from '@mantine/core';
import { IconArrowsLeftRight, IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { useState } from 'react';
import templateWizardFormFields from '../../../constants/templateWizardFormFields';
import TemplateFields from './templateFields';

const ArrowsStyles = ({ disabled, handleChangeStyles, productBlockStyles, handleChangeColors }) => {
  const [open, setOpen] = useState(false);

  return (
    <Card withBorder>
      <Card.Section inheritPadding py="sm">
        <UnstyledButton onClick={() => setOpen(!open)} w="100%">
          <Group justify="space-between">
            <Group gap="xs">
              <IconArrowsLeftRight size={18} color="var(--mantine-color-dimmed)" />
              <Text fw={500}>Slider Navigation Styles</Text>
            </Group>
            {open ? <IconChevronUp size={18} /> : <IconChevronDown size={18} />}
          </Group>
        </UnstyledButton>
      </Card.Section>
      <Collapse expanded={open}>
        <Card.Section inheritPadding py="sm">
          <Text size="sm" fw={500} ta="center" mb="xs">
            Arrows Position
          </Text>
          <TemplateFields
            disabled={disabled}
            handleChangeStyles={handleChangeStyles}
            productBlockStyles={productBlockStyles}
            handleChangeColors={handleChangeColors}
            fieldConfigs={templateWizardFormFields.arrowsFields}
          />
        </Card.Section>
      </Collapse>
    </Card>
  );
};

export default ArrowsStyles;
